import React, { useEffect } from "react";

import { useDispatch, useSelector } from "react-redux";
import TestsRequests from "services/tests";
import GridContainer from "@jumbo/components/GridContainer";
import { Grid } from "@material-ui/core";
import { Box, Typography } from "@material-ui/core";

import EventElement from "./EventElement";

const AllMarathonEvents = () => {
  const { allMarathonEvents } = useSelector(({ tests }) => tests);
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(TestsRequests.getAllMarathonEvents(1));
  }, []);

  return (
    <>
      <GridContainer>
        <Grid item xs={12}>
          {allMarathonEvents.length === 0 && (
            <Box
              display={"flex"}
              justifyContent={"center"}
              paddingTop={"30px"}
              paddingBottom={"20px"}
            >
              <Typography variant="h3">موردی برای نمایش وجود ندارد</Typography>
            </Box>
          )}
          {allMarathonEvents &&
            allMarathonEvents.map((item) => (
              <EventElement data={item} key={item._id} />
            ))}
        </Grid>
      </GridContainer>
    </>
  );
};

export default AllMarathonEvents;
